import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const SumoPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Robo Guard Challenge";
  }, []);
  return <CategoryDetailTemplate />;
};

export default SumoPage;
